// 根据配置项生成并显示菜单函数
// import jsPlumb from 'jsplumb'
// import api from '@/service/api'
export const myMixin = {
  methods: {
    showContextmenu(className, x, y, menuList, node) {
      const menuContainer = document.querySelector('.' + className)
      menuContainer.style.display = 'block'

     
      menuContainer.innerHTML = ''
      menuList.forEach((item) => {
        const menuItem = document.createElement('li')
        if (item !== '分割线') {
          menuItem.innerHTML = `<div class="fontIcon"><i class="fa ${item.icon}"></i></div>&nbsp;&nbsp;&nbsp;${item.name}`
          menuItem.className = 'menuItemClass'
          // menuItem.addEventListener('click', () => item.fun(node, nodes))
          
         
          menuItem.addEventListener('click', () => { 
           if(item.name === "删除云端连线"){
            item.fun(node)
            return
           }
            if(node?.type === 'line'){
              const param =node.lineId
            
              api.vms.bridges.delete(param).response.then((res) => {
              // api.vms.bridges.delete_line(params).response.then((res) => {
                res = res.data
                if(res.code === 200){
  
                  item.fun(node)
                  this.$message.success('删除成功')
                  this.$bus.$emit('deleteList')
                }else{
                  this.$message.error('删除失败')
                }
              })
              return 
            }
            item.fun(node)

            // console.log('node11111', node)
            // if ((node.sourceId === 'img188' && node.targetId === 'img167') ||
            //     (node.sourceId === 'img167' && node.targetId === 'img188') ||
            //     (node.sourceId === 'img190' && node.targetId === 'img167') ||
            //     (node.sourceId === 'img167' && node.targetId === 'img190')
            // ) { // 断开云端
            //   const params = {
            //     start_type: 'Node',
            //     start_id: 167,
            //     end_type: 'cloud',
            //     end_id: 0,
            //     ip_address: '192.168.0.211/24'
            //   }
            //   api.vms.virtual_machine_networks.delete_link(params, {}).response.then(res => res)
            //   return this.$message('云端已断开')
            // } else if (node.id) {
            //   this.$message('删除成功')
            //   this.$bus.$emit('deleteList')
            // }
          }
          )
        } else {
          menuItem.className = 'divider'
        }
        menuContainer.appendChild(menuItem)
      })
      const clientWidth = menuContainer.clientWidth
      const width = window.outerWidth
      if(x + clientWidth >width ){
       x = width - clientWidth
      }
       menuContainer.style.left = x + 'px'
       const clientHeight = menuContainer.clientHeight
      const height = window.outerHeight
      if(y + clientHeight >height ){
        y = height - clientHeight
       }
       menuContainer.style.top = (y-60)  + 'px' // 修改根据鼠标右击位置显示信息框的高度
    },
    // 隐藏菜单函数
    hideContextmenu(className, e) {
      if (e.button !== 0) return
      const menuContainer = document.querySelector('.' + className)
      if (menuContainer) {
        menuContainer.style.display = 'none'
      }
    },
    // 根据target显示不同菜单（新增菜单、节点菜单、框选菜单）
    showMenu(className, nodeClassName, selectedClassName, e) {
      console.log('右击鼠标', className, nodeClassName, selectedClassName)
      this.position.left = e.clientX
      console.log('位置信息', this.position)
      // console.log('left', this.position.left)
      console.log('e', e)
      this.$store.commit('eve/SET_LAYER', e)
      this.position.top = e.clientY
      let uservalue = e.target?.parentElement.attributes?.uservalue?.value 
      // e.target?.attributes?.uservalue?.value
      if(uservalue){
        uservalue = JSON.parse(uservalue).name
      }else{
        uservalue = ''
      } // 拿节点名称转对象
      // console.log('top', this.position.top)
      if (e.target.nodeName === 'path') return
      else if(document.querySelectorAll('.' + selectedClassName).length === 0 &&
      uservalue.indexOf('cloud')>-1){
        this.showContextmenu(
          className,
          e.clientX,
          e.clientY, 
          [
          ...this.editAndDelList
          ],
          e
          )
        return
      }
      else if (e.target.id === 'NParent188' || e.target.id === 'NParent190') {
        return
      } else if (
        document.querySelectorAll('.' + selectedClassName).length > 0 &&
              e.target.parentElement.className.indexOf(selectedClassName) > -1
      ) {
        this.showContextmenu(className, e.clientX, e.clientY, this.setectedMenuList)
        return
      } else if (
        document.querySelectorAll('.' + selectedClassName).length === 0 &&
              e.target.parentElement.className.indexOf(nodeClassName) > -1
      ) {
        this.showContextmenu(
          className,
          e.clientX,
          e.clientY,
          [
            ...this.nodeMenuList
          ],
          e
        )
        return
      } else if (document.querySelectorAll('.' + selectedClassName).length === 0) {
        this.showContextmenu(className, e.clientX, e.clientY, [...this.addNewObjectMenuList, '分割线', ...this.autoAlign])
        return
      }
      
    },
    // 显示线段右键菜单
    showEdgeContextmenu(className, info, e) {
      console.log("云的id",this.$store.state.eve.could_line_id);
      console.log("云线的一端id",info.sourceId.slice(3));
      console.log("云线的另一端id",info.targetId.slice(3));
      if(this.$store.state.eve.could_line_id.id == info.sourceId.slice(3) || 
      this.$store.state.eve.could_line_id.id == info.targetId.slice(3)){
        this.showContextmenu(className, e.clientX, e.clientY, [...this.edgeCloudmenu], info)
        console.log("this.showContextmenu",this.showContextmenu);
        return
      }
      this.showContextmenu(className, e.clientX, e.clientY, [...this.edgeContextmenu], info)
      console.log("this.手动阀沙发",this.showContextmenu);
    }
  }
}
